"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rowIndexToBeDeletedSelector = exports.systemOfEvaluatorToBeDeletedSelector = exports.evaluatorToBeDeletedSelector = exports.isRemoveEvaluatorDialogOpenSelector = exports.isSendingEvaluatorToSystemSelector = exports.evaluatorsToastStatusSelector = exports.evaluatorsGroupsSelector = exports.areEvaluatorsGroupsLoadingSelector = exports.siteTabsSelector = exports.areTabsLoadingSelector = void 0;
const areTabsLoadingSelector = (state) => {
    return state.evaluators.areTabsLoading;
};
exports.areTabsLoadingSelector = areTabsLoadingSelector;
const siteTabsSelector = (state) => {
    return state.evaluators.siteTabs;
};
exports.siteTabsSelector = siteTabsSelector;
const areEvaluatorsGroupsLoadingSelector = (state) => {
    return state.evaluators.areEvaluatorsGroupsLoading;
};
exports.areEvaluatorsGroupsLoadingSelector = areEvaluatorsGroupsLoadingSelector;
const evaluatorsGroupsSelector = (state) => {
    const evaluatorsGroups = [...state.evaluators.evaluatorsGroups];
    return evaluatorsGroups?.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
};
exports.evaluatorsGroupsSelector = evaluatorsGroupsSelector;
const evaluatorsToastStatusSelector = (state) => {
    return state.evaluators.evaluatorsToastStatus;
};
exports.evaluatorsToastStatusSelector = evaluatorsToastStatusSelector;
const isSendingEvaluatorToSystemSelector = (state) => state.evaluators.isSendingEvaluatorToSystem;
exports.isSendingEvaluatorToSystemSelector = isSendingEvaluatorToSystemSelector;
const isRemoveEvaluatorDialogOpenSelector = (state) => {
    return state.evaluators.isDeleteAlertDialogShown;
};
exports.isRemoveEvaluatorDialogOpenSelector = isRemoveEvaluatorDialogOpenSelector;
const evaluatorToBeDeletedSelector = (state) => {
    return state.evaluators.evaluatorToBeDeleted;
};
exports.evaluatorToBeDeletedSelector = evaluatorToBeDeletedSelector;
const systemOfEvaluatorToBeDeletedSelector = (state) => {
    return state.evaluators.systemOfEvaluatorToBeDeleted;
};
exports.systemOfEvaluatorToBeDeletedSelector = systemOfEvaluatorToBeDeletedSelector;
const rowIndexToBeDeletedSelector = (state) => {
    return state.evaluators.rowIndexToBeDeleted;
};
exports.rowIndexToBeDeletedSelector = rowIndexToBeDeletedSelector;
